import { ElementType, FC, ReactNode } from 'react';

import cs from 'classnames';

import styles from './Title.module.scss';

type TitleProps = {
  title: string;
  headingTag?: ElementType;
  children?: ReactNode;
  textAlign?: 'left' | 'right' | 'center';
  className?: string;
};

const Title: FC<TitleProps> = ({
  title,
  headingTag: Tag = 'h3',
  children,
  textAlign = 'center',
  className
}) => (
  <div className={cs(styles.container, className)}>
    <Tag style={{ textAlign }}>{title}</Tag>
    {children && <p>{children}</p>}
  </div>
);

export default Title;
